'use strict';

var FocusHandler = function(childrenViews) {
    this.childrenViews = childrenViews;

    this.onChildFulfilled = function() {
        if (this.isEmptyOrHasError()) {
            this.setFocus();
        }
    };

    this.isEmptyOrHasError = function() {
        return Odigeo._.some(this.childrenViews, function(view) {
            return view.isEmptyOrHasError();
        });
    };

    this.setFocus = function() {
        var view = Odigeo._.chain(this.childrenViews)
            .filter(function(view) {
                return view.isEmptyOrHasError();
            })
            .head()
            .value();

        if (view) {
            view.setFocus();
        }
    };
};
module.exports = FocusHandler;
